/*
 * @Description: get-mini-app-methods 导出mini-app方法
 * @Author: fiveonelei
 * @Date: 2022-02-10 10:59:15
 * @FilePath: /vise/packages/app-share/src/composable/use-get-common-method/get-mini-app-methods.ts
 */
import { useRoute } from 'vue-router';
import { useStore } from '@/store/index';
import { EMiniAppPosition } from '@/constants/mini-app';
import miniApp, { MiniAppPathUrlParams } from '@/utils/mini-app';

export default function useGetMiniAppMethods() {
  const { state } = useStore();
  const route = useRoute();

  const getMiniAppPath = function (position: EMiniAppPosition, params: MiniAppPathUrlParams = {}) {
    const { query = {} } = route || {};
    const { growthTestData } = state;
    return miniApp.getMiniAppPath(position, {
      ...params,
      growthTestData,
      query,
    });
  };
  const getMiniAppReportValue = function (position: EMiniAppPosition) {
    const { growthTestData } = state;
    return miniApp.getMiniAppPath(position, { growthTestData });
  };
  return {
    getMiniAppPath, getMiniAppReportValue,
  };
}
